define(['app/models/messages', 'app/models/popup'], function (Messages, PkPopup) {
    function CartMessages() {
        const publics = {};
        const privates = {};
        const translate = partyking.common.helpers.l.translate;
        const { StaticPopup, DynamicPopup, ChoicePopup, createChoice } = new PkPopup();

        const getCheckoutUrl = () => {
            const checkoutUrls = new Map([
                ['sv_SE.UTF8', 'kassa.html'],
                ['nb_NO.UTF8', 'kasse.html'],
                ['da_DK.UTF8', 'kasse.html'],
                ['fi_FI.UTF8', 'kassa.html'],
            ]);

            return checkoutUrls.get(partyking.config.locale);
        };

        publics.onlyOneFreeCrapAllowed = () =>
            new StaticPopup(
                translate(
                    "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>Ajabaja!</span>Endast en gratispryl per order!"
                )
            ).render();

        publics.notAllowedToVisitCheckoutWithOnlyFreeCrap = () =>
            new StaticPopup(
                translate(
                    "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>Sakta i backarna!</span>Lägg en vara i kundkorgen för att få gratis studentballonger!"
                )
            ).render();

        publics.onlyFreeCrapNotAllowedInCheckout = () =>
            new StaticPopup(
                translate(
                    "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>Sakta i backarna!</span>Du kan inte besöka kassan med enbart gratis studentballonger. Kom tillbaka med andra produkter!"
                )
            ).render();

        publics.removeLastItemLeavingOnlyFreeCrap = (cb) => {
            const choices = [
                createChoice(translate('Nej'), 'w-full px-2 mr-2 pk-button-yellow-cta', 'close-cta'),
                createChoice(translate('Ja'), 'w-full px-2 pk-button-grey', 'remove-cta', cb),
            ];
            new ChoicePopup(
                translate(
                    "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>Oops!</span>Om du tar bort den här produkten kommer också gratis studentballonger att försvinna. Vill du fortsätta?"
                ),
                choices
            ).render();
        };

        publics.overStockWarning = (product) =>
            new DynamicPopup(
                translate(
                    "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>You snooze you lose!</span>Någon hann tyvärr före dig och din varukorg innehåller därför inte längre tillräckligt många av följande: "
                ),
                product
            ).render();

        publics.overStockOnPaymentWarning = (product) =>
            new DynamicPopup(
                translate(
                    "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>Köp avbrutet</span>Någon hann tyvärr före dig och din varukorg innehåller därför inte längre tillräckligt många av följande: "
                ),
                product
            ).render();

        publics.overStockQuntityIncreasedWarning = () =>
            new StaticPopup(
                translate(
                    "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>Lagerstatus</span>Tyvärr har vi inga fler exemplar tillgängliga av denna produkt. Kontakta kundtjänst om du önskar beställa fler exemplar."
                )
            ).render();

        publics.cartLoadedAllItemsMissing = () =>
            new StaticPopup(
                translate(
                    "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>KUNDE INTE UPPDATERA VARUKORG</span>Produkterna i den inlästa varukorgen är tyvärr slut i lager :-("
                )
            ).render();

        publics.cartLoadedMessage = (missingItems) => {
            const choices = [
                createChoice(
                    translate('gå till kassan'),
                    'w-full px-2 mr-2 pk-button-yellow-cta',
                    'cta-to-checkout-page',
                    () => (window.location.href = getCheckoutUrl())
                ),
                createChoice(translate('fortsätt handla'), 'w-full px-2 pk-button-grey', 'close-cta'),
            ];
            new ChoicePopup(
                missingItems.length === 0
                    ? privates.cartLoadedNoMissingItems()
                    : privates.cartLoadedMissingItems(missingItems),
                choices
            ).render();
        };

        privates.cartLoadedMissingItems = (missingProducts) => {
            let html = translate(
                `<span style='display:block;text-align:center; font-weight:bold; width:100%;'>DIN VARUKORG HAR UPPDATERATS</span> Tyvärr finns inte alla produkter i lager `
            );
            return (html += privates.constructList(missingProducts).outerHTML);
        };

        privates.cartLoadedNoMissingItems = () =>
            translate(
                "<span style='display:block;text-align:center; font-weight:bold; width:100%;'>DIN VARUKORG HAR UPPDATERATS</span>Har du allt du behöver till festen?"
            );

        privates.constructLiElement = (product) => {
            const li = document.createElement('li');
            const isAdmin = partyking.office === 1;
            const productName = `${product.name} ${product.alternativeName}`;
            const quantity = `${product.foundQuantity} / ${product.expectedQuantity}`;

            if (isAdmin) {
                const anchor = document.createElement('a');
                anchor.href = `//${product.url}`;
                anchor.className = 'text-danger font-bold';
                anchor.target = '_blank';
                anchor.textContent = `${product.artNum} ${productName} - ${quantity}`;
                li.appendChild(anchor);

                return li;
            }

            li.textContent = `${productName} - ${quantity} `;
            return li;
        };

        privates.constructList = (missingProducts) => {
            const ul = document.createElement('ul');
            ul.className = 'mt-2';

            missingProducts.forEach((product) => ul.appendChild(privates.constructLiElement(product)));

            return ul;
        };

        return publics;
    }
    return CartMessages;
});
